import * as React from "react";
import Snackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";
import Alert, { AlertColor } from "@mui/material/Alert";
import { SxProps, Theme } from "@mui/material/styles";

type HorizontalType = "center" | "left" | "right";
type VerticalType = "top" | "bottom";
type VariantType = "filled" | "standard" | "outlined";
export interface SnackbarAlertProps {
  message: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  autoHideDuration?: number;
  horizontal?: HorizontalType;
  severity?: AlertColor;
  sx?: SxProps<Theme>;
  variant?: VariantType;
  vertical?: VerticalType;
  action?: React.JSX.Element;
}

export default function SnackbarAlert(props: SnackbarAlertProps) {
  const {
    message,
    open,
    setOpen,
    autoHideDuration,
    horizontal,
    severity,
    sx,
    variant,
    vertical,
    action,
  } = props;

  const defaultAutoHideDuration = 3000;
  const defaultHorizontal: HorizontalType = "center";
  const defaultSeverity: AlertColor = "info";
  const defaultVariant: VariantType = "filled";
  const defaultVertical: VerticalType = "top";

  const handleClose = (
    _event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <div>
      <Snackbar
        anchorOrigin={{
          horizontal: horizontal ?? defaultHorizontal,
          vertical: vertical ?? defaultVertical,
        }}
        open={open}
        autoHideDuration={autoHideDuration ?? defaultAutoHideDuration}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={severity ?? defaultSeverity}
          variant={variant ?? defaultVariant}
          sx={sx}
          autoCapitalize="sentences"
        >
          {message} {action}
        </Alert>
      </Snackbar>
    </div>
  );
}
